import { Translation } from '@ps/web-shared-components';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import Toggle from '@swf/components/Inputs/Toggle';
import { select } from '@swf/core/store';
import { required } from '@swf/core/utils/validators';

import AccountInfoMessage from '../AccountInfoMessage/AccountInfoMessage';
import AddressFields from '../AddressForm/AddressFields/AddressFields';
import AddressFormLayout from '../AddressForm/AddressFormLayout/AddressFormLayout';
import StreetAddressExtended from '../AddressForm/StreetAddressExtended/StreetAddressExtended';

import {
  TXTCLI_A_SCHUFA_check_will_be_perform_ELL,
  TXTCLI_German_regulations_require_us__ELL,
  TXTCLI_I_understand_that_my_account_m_ELL,
  TXTCLI_You_have_1_day_to_check_that_y_ELL_1,
  TXTCLI_You_have_N0_days_to_check_that_ELL_1
} from './DeAnnualAttestationAddressForm.messages.json';
import DeAnnualAttestationAddressFullName from './DeAnnualAttestationAddressFullName/DeAnnualAttestationAddressFullName';
import useOnCompleteAttestation, { agreementId } from './useOnCompleteAttestation';

interface Props {
  disabled?: boolean;
  className?: string;
  setMessageNode?: (node: React.ReactNode) => void;
  setResult?: (result: 'success' | 'fail') => void;
  submitButtonBlock?: boolean;
}

const DeAnnualAttestationAddressForm = ({
  disabled,
  className,
  setMessageNode,
  setResult,
  submitButtonBlock = false
}: Props) => {
  const { docsDaysLeft = 30 } = useSelector(select.account.get);
  const fullName = useSelector(select.account.getFullName);
  const onCompleteAttestation = useOnCompleteAttestation({ setMessageNode, setResult });

  useEffect(() => {
    setMessageNode?.(
      <AccountInfoMessage type="warning">
        <span>
          <Translation {...TXTCLI_German_regulations_require_us__ELL} />{' '}
          <Translation
            {...(docsDaysLeft === 1
              ? TXTCLI_You_have_1_day_to_check_that_y_ELL_1
              : {
                  ...TXTCLI_You_have_N0_days_to_check_that_ELL_1,
                  values: { 0: docsDaysLeft }
                })}
          />{' '}
          <Translation {...TXTCLI_A_SCHUFA_check_will_be_perform_ELL} />
        </span>
      </AccountInfoMessage>
    );
  }, [docsDaysLeft, setMessageNode]);

  return (
    <AddressFormLayout
      onSubmit={onCompleteAttestation}
      submitButtonBlock={submitButtonBlock}
      className={className}
      optionalInitialData={{ fullName }}
    >
      {(form, submitButton) => (
        <>
          {form.submitError}
          <DeAnnualAttestationAddressFullName />
          <AddressFields disabled={disabled} showStates={true} restricted={false}>
            <StreetAddressExtended disabled={disabled} />
          </AddressFields>
          <Toggle
            label={TXTCLI_I_understand_that_my_account_m_ELL}
            id={agreementId}
            type="checkbox"
            validators={[required()]}
          />
          {submitButton}
        </>
      )}
    </AddressFormLayout>
  );
};

export default DeAnnualAttestationAddressForm;
